import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useInterviewStorePools from './useInterviewStorePools';

const useSingleInterviewStorePool = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, typesInterview } = useInterviewStorePools(
    false,
    false,
  );

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    typesInterview,
  };
};

export default useSingleInterviewStorePool;
